module.exports = __webpack_public_path__ + "img/deleteLogo.cf7da808.svg";